module.exports = __webpack_public_path__ + "static/media/gm.f06a98cd.svg";